import React from 'react';
import { SanityController } from './sanity';
import { Option } from '../utilityTypes';

const defaultValue = new Proxy(
    {},
    {
        get: () => {
            throw new Error(
                'Invalid store, please check context instantiation'
            );
        },
    }
) as SanityController;

const SanityContext = React.createContext<SanityController>(defaultValue);
const useSanity = (): SanityController => React.useContext(SanityContext);

const LandingPageCTAQueryParamContext =
    React.createContext<Option<Record<string, string>>>(undefined);
const useLandingCTAQueryParam = (): Option<Record<string, string>> =>
    React.useContext(LandingPageCTAQueryParamContext);

export type SSRContextData = {
    title?: string;
    description?: string;
    image?: string;
    setOpenGraphData: (
        title: string,
        description: string,
        image?: string
    ) => void;
};

function createSSRContext(): SSRContextData {
    return {
        setOpenGraphData: function (
            title: string,
            description: string,
            image?: string
        ) {
            this.title = title;
            this.description = description;
            this.image = image;
        },
    };
}

const SSRContext = React.createContext<SSRContextData>(createSSRContext());
const useSSR = (): SSRContextData => React.useContext(SSRContext);

export {
    useSanity,
    useLandingCTAQueryParam,
    LandingPageCTAQueryParamContext,
    SanityContext,
    useSSR,
    createSSRContext,
    SSRContext,
};
